import { render, staticRenderFns } from "./LicenceExpiration.vue?vue&type=template&id=4967d8be&scoped=true"
import script from "./LicenceExpiration.vue?vue&type=script&lang=js"
export * from "./LicenceExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967d8be",
  null
  
)

export default component.exports